import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'components/ui/use-toast'
import requests from 'service/api'

export function useSizeGroupList(brand) {
  return useQuery({
    queryKey: ['sizeGroups', brand],
    queryFn: async () => {
      const { data } = await requests.sizeGroup.list(brand)
      return data?.data || []
    },
    enabled: !!brand,
    placeholderData: []
  })
}

export function useSizeGroup(id, brand) {
  return useQuery({
    queryKey: ['sizeGroup', id, brand],
    queryFn: async () => {
      const { data } = await requests.sizeGroup.get(id, brand)
      return data?.data
    },
    enabled: !!id && !!brand
  })
}

export function useCreateSizeGroup() {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: (body) => requests.sizeGroup.create(body),
    onSuccess: (response, variables) => {
      const brand = variables.brand
      queryClient.invalidateQueries({ queryKey: ['sizeGroups', brand] })
      toast.success('Beden grubu oluşturuldu')
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || 'SizeGroup oluşturulurken bir hata oluştu'
      toast.error(errorMessage)
    }
  })
}

export function useUpdateSizeGroup() {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: ({ id, body }) => requests.sizeGroup.update(id, body),
    onSuccess: (response, variables) => {
      const brand = variables.body.brand
      queryClient.invalidateQueries({ queryKey: ['sizeGroups', brand] })
      queryClient.invalidateQueries({ queryKey: ['sizeGroup', variables.id, brand] })
      toast.success('Beden grubu güncellendi')
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || 'SizeGroup güncellenirken bir hata oluştu'
      toast.error(errorMessage)
    }
  })
}

export function useDeleteSizeGroup() {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: ({ id, brand }) => requests.sizeGroup.delete(id, brand),
    onSuccess: (response, variables) => {
      queryClient.invalidateQueries({ queryKey: ['sizeGroups', variables.brand] })
      toast.success('Beden grubu silindi')
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || 'SizeGroup silinirken bir hata oluştu'
      toast.error(errorMessage)
    }
  })
}

export function useAddSizeToGroup() {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: ({ id, body }) => requests.sizeGroup.addSize(id, body),
    onSuccess: (response, variables) => {
      const brand = variables.body.brand
      queryClient.invalidateQueries({ queryKey: ['sizeGroup', variables.id, brand] })
      queryClient.invalidateQueries({ queryKey: ['sizeGroups', brand] })
      toast.success('Beden eklendi')
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || 'Size eklenirken bir hata oluştu'
      toast.error(errorMessage)
    }
  })
}

export function useUpdateSizeInGroup() {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: ({ id, sizeIndex, body }) => requests.sizeGroup.updateSize(id, sizeIndex, body),
    onSuccess: (response, variables) => {
      const brand = variables.body.brand
      queryClient.invalidateQueries({ queryKey: ['sizeGroup', variables.id, brand] })
      queryClient.invalidateQueries({ queryKey: ['sizeGroups', brand] })
      toast.success('Size başarıyla güncellendi')
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || 'Size güncellenirken bir hata oluştu'
      toast.error(errorMessage)
    }
  })
}

export function useDeleteSizeFromGroup() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, sizeIndex, brand }) => requests.sizeGroup.deleteSize(id, sizeIndex, brand),
    onSuccess: (response, variables) => {
      queryClient.invalidateQueries({ queryKey: ['sizeGroup', variables.id, variables.brand] })
      queryClient.invalidateQueries({ queryKey: ['sizeGroups', variables.brand] })
      toast.success('Beden silindi')
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || 'Beden silinirken bir hata oluştu'
      toast.error(errorMessage)
    }
  })
}

export function useUpdateSizeRow() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, sizeId, body }) => requests.sizeGroup.updateSizeRow(id, sizeId, body),
    onSuccess: (response, variables) => {
      const brand = variables.body.brand
      queryClient.invalidateQueries({ queryKey: ['sizeGroup', variables.id, brand] })
      queryClient.invalidateQueries({ queryKey: ['sizeGroups', brand] })
      toast.success('Beden güncellendi')
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || 'Beden güncellenirken bir hata oluştu'
      toast.error(errorMessage)
    }
  })
}

export function useDeleteSizeRow() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, sizeId, brand }) => requests.sizeGroup.deleteSizeRow(id, sizeId, brand),
    onSuccess: (response, variables) => {
      queryClient.invalidateQueries({ queryKey: ['sizeGroup', variables.id, variables.brand] })
      queryClient.invalidateQueries({ queryKey: ['sizeGroups', variables.brand] })
      toast.success('Beden silindi')
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || 'Beden silinirken bir hata oluştu'
      toast.error(errorMessage)
    }
  })
}
